import { DropdownOptions } from "../components/FormFields/DropdownField";

export const ReportedGenderOptions: DropdownOptions[] = [
  { value: "Female" },
  { value: "Male" },
  { value: "Other" },
  { value: "Prefer Not to Say" },
];
